import * as React from 'react';
import { IContextualMenuItem, IIconProps, CommandBarButton, Spinner } from 'office-ui-fabric-react';
import { post } from '../../../fetch-interceptor';
import { IFindResult } from './EntityPickerInput';

type MenuButtonPickerProps = {
    text?: string;
    title?: string;
    iconProps?: IIconProps;
    findUrl: string;
    disabled?: boolean;
    filter?: any;
    onMenuItemClick?: (item: IFindResult) => void;
    isItemDisabled?: (item: IFindResult) => boolean;
}

export const MenuButtonPicker = (props: MenuButtonPickerProps) => {
    const [items, setItems] = React.useState<IFindResult[] | undefined>();
    const [isLoading, setIsLoading] = React.useState(false);

    const onMenuOpened = React.useCallback(() => {
        if (items?.length) {
            return;
        }

        post<IFindResult[]>(props.findUrl, props.filter)
            .then(data => setItems(data ?? []))
            .finally(() => setIsLoading(false));
        setIsLoading(true);
    }, [props.findUrl, items]);

    const menuItems = React.useMemo(() => {
        return items?.map(_ => ({
            key: _.id,
            name: _.name,
            iconProps: {},
            disabled: props.disabled || props.isItemDisabled?.(_),
            onClick: () => props.onMenuItemClick?.(_),
        } as IContextualMenuItem)) ?? [];
    }, [items, props.isItemDisabled, props.onMenuItemClick])

    return <CommandBarButton
        text={props.text}
        onRenderMenuIcon={(props, defaultRender) => isLoading ? <Spinner/> : defaultRender?.(props) ?? null}
        disabled={props.disabled}
        iconProps={props.iconProps}
        title={props.title}
        menuProps={{
            useTargetAsMinWidth: true,
            calloutProps: { className: "header-callout" },
            items: menuItems,
            onMenuOpened: onMenuOpened
        }}
    />;
}